var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('keep-alive',{attrs:{"include":"PdfReaderHome"}},[(_vm.$route.meta && _vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!(_vm.$route.meta && _vm.$route.meta.keepAlive))?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }